import { Stack, Tooltip, Typography } from "@mui/material";
import { dayjs, formatDate, formatDateTime, EContractState } from "@synota-io/synota-shared-ui";
import { formatHoursSinceDate, getHoursSinceDate } from "../../../../utils/date";
import { numberToColor } from "../../../../utils/color";
import { IDashboardContract } from "../../../../api/hooks/useContracts";

export const LastInvoiceDateCell = ({ row, value }: { row: IDashboardContract; value: string }) => {
  if (!value || row.contract_state === EContractState.Unsigned) {
    return "N/A";
  }
  const date = dayjs(value);
  const hoursSinceDate = getHoursSinceDate(date);
  const formatted = formatHoursSinceDate(date, hoursSinceDate);

  const disableTooltip = !row.last_invoice_date && !row.last_invoice_start_time;

  return (
    <Tooltip
      arrow
      placement="left"
      disableHoverListener={disableTooltip}
      disableTouchListener={disableTooltip}
      title={
        <Typography component={Stack} gap={1} variant="body2" fontWeight={500}>
          {row.last_invoice_date ? (
            <span>
              <span>Invoice Date: </span>
              <strong>{formatDateTime(row.last_invoice_date)}</strong>
            </span>
          ) : null}
          {row.last_invoice_start_time ? (
            <span>
              <span>Energy Date </span>
              <strong>{formatDate(row.last_invoice_start_time)}</strong>
            </span>
          ) : null}
        </Typography>
      }
    >
      <Typography variant="inherit" fontWeight="bold" sx={{ color: numberToColor(hoursSinceDate) }}>
        {formatted}
      </Typography>
    </Tooltip>
  );
};
